import { createQueryKeyStore } from '@lukemorales/query-key-factory';

import { fetchDocumentIsOpen } from '~extension/web2print/controller/api/document';
import { fetchDuplicateFormSettings } from '~extension/web2print/controller/api/duplicateForm';
import {
  getExportDocument,
  getExportDocumentMyFiles,
  getExportJob,
  getExportJobMyFiles,
  getExportStatus,
  getExportTicket,
} from '~extension/web2print/controller/api/export';
import { fetchJobList, isOpen } from '~extension/web2print/controller/api/job';
import { getSapDownloadUrl, getSapParameters } from '~extension/web2print/controller/api/sap';
import { makeDocumentIsOpen } from '~extension/web2print/model/DocumentIsOpenFactory';
import { makeExportStatusFactory } from '~extension/web2print/model/ExportStatusFactory';
import { makeFormSettings } from '~extension/web2print/model/FormSettingsFactory';
import { makeJobList } from '~extension/web2print/model/JobListFactory';
import { makeSapDownload } from '~extension/web2print/model/SapDownloadFactory';
import { makeSapParameters } from '~extension/web2print/model/SapParametersFactory';

export const queries = createQueryKeyStore({
  web2print: {
    duplicateFormSettings: (assetId: string) => ({
      queryKey: [assetId],
      queryFn: async () => makeFormSettings(await fetchDuplicateFormSettings(assetId)),
    }),
    jobList: (status: string) => ({
      queryKey: [status],
      queryFn: async () => makeJobList(await fetchJobList(status)),
    }),
    jobIsOpen: (documentId: number, jobId: number, clientId: number, formatId: number) => ({
      queryKey: ['job-open' + documentId + '-' + jobId + '-' + clientId + '-' + formatId],
      queryFn: async () => Boolean(await isOpen(jobId, clientId)),
    }),
    documentIsOpen: (documentId: number, clientId: number) => ({
      queryKey: [documentId + '-' + clientId],
      queryFn: async () => makeDocumentIsOpen(await fetchDocumentIsOpen(documentId, clientId)),
    }),
    getExportTicket: (documentId: number, jobId: number, clientId: number, formatId: number) => ({
      queryKey: ['export-ticket' + documentId + '-' + jobId + '-' + clientId + '-' + formatId],
      queryFn: async () => String(await getExportTicket()),
    }),
    exportJob: (jobId: number, clientId: number, exportTicket: string) => ({
      queryKey: ['download-' + jobId + '-' + clientId + '-' + exportTicket],
      queryFn: async () => Boolean(await getExportJob(jobId, clientId, exportTicket)),
    }),
    exportJobMyFiles: (jobId: number, clientId: number) => ({
      queryKey: ['myfiles-' + jobId + '-' + clientId],
      queryFn: async () => Boolean(await getExportJobMyFiles(jobId, clientId)),
    }),
    exportDocument: (documentId: number, clientId: number, formatId: number, exportTicket: string) => ({
      queryKey: ['download-' + documentId + '-' + clientId + '-' + formatId + '-' + exportTicket],
      queryFn: async () => Boolean(await getExportDocument(documentId, clientId, formatId, exportTicket)),
    }),
    exportDocumentMyFiles: (documentId: number, clientId: number, formatId: number) => ({
      queryKey: ['myfiles-' + documentId + '-' + clientId + '-' + formatId],
      queryFn: async () => Boolean(await getExportDocumentMyFiles(documentId, clientId, formatId)),
    }),
    getExportStatus: (exportTicket: string) => ({
      queryKey: [exportTicket],
      queryFn: async () => makeExportStatusFactory(await getExportStatus(exportTicket)),
    }),
    getSapParameters: () => ({
      queryKey: ['sap-parameters'],
      queryFn: async () => makeSapParameters(await getSapParameters()),
    }),
    getSapDownloadUrl: (documentId: number, clientId: number) => ({
      queryKey: ['sap-download-' + documentId + '-' + clientId],
      queryFn: async () => makeSapDownload(await getSapDownloadUrl(documentId, clientId)),
    }),
  },
});
